import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BusinessProfile.css";
import Header from "../../Components/Header/Header";
import image from "../../Assets/portrait-successful-handsome-executive-businessman-smart-casual-wear-looking-camera-smiling.jpg";
import * as Ci from "react-icons/ci";
import * as Bs from "react-icons/bs";
import { AppContext } from "../../Context/AppContext";
import Backbutton from "../../Components/Header/Backbutton";
import toast, { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import placeholder from "../../Assets/company.png";
import { Modal } from "antd";

function BusinessProfile() {
  const navigate = useNavigate();
  const {
    profileList,
    getBusinessProfile,
    deleteProfile,
    businessProfileLoading,
    getAllUserReview,
  } = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [acknowledge, setAcknowledge] = useState(false);
  const [selectedId, setSelectedId] = useState(0);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = profileList.slice(indexOfFirstItem, indexOfLastItem);

  const deleteBusinessProfile = async () => {
    if (!selectedId === 0) {
      console.error("Profile ID is missing!");
      return;
    }
    await deleteProfile(selectedId, {
      onSuccess: async (res) => {
        toast.success("Business Profile Deleted Successfully!");
        setAcknowledge(false);
        await getBusinessProfile();
        await getAllUserReview();
        setTimeout(() => {});
      },
      onFailed: (err) => {
        toast.error("Something went Wrong!");
        console.error(err);
      },
    });
  };

  return (
    <div className="container-fluid background">
      <Toaster position="top-center" reverseOrder={false} />
      <Header />
      <Modal
        open={acknowledge}
        onCancel={() => setAcknowledge(false)}
        footer={null}
        maskClosable={false}
      >
        <h5>Confirm Action</h5>
        <hr />
        <p className="aknowledge_text">
          Would you like to proceed and delete this Business profile?
        </p>
        <p className="aknowledge_text_sub">
          <i className="text-danger">
            ⚠️ <b>Warning</b>: Deleting this business profile will also remove
            all reviews associated with it, even though they were created by
            users.
          </i>
        </p>
        <br />
        <div className="d-flex justify-content-end gap-2">
          <button
            className="modal_btn py-2 confirm_btn"
            onClick={deleteBusinessProfile}
            disabled={businessProfileLoading}
          >
            {businessProfileLoading ? (
              <div class="text-center">
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                ></div>
              </div>
            ) : (
              "Confirm"
            )}
          </button>
          <button
            className="modal_btn py-2 cancel_btn"
            onClick={() => setAcknowledge(false)}
            disabled={businessProfileLoading}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <div className="mains">
        <div class="table-title data">
          <div class="flex-cont mb-3">
            <div class="flex-start m-1">
              <h4 class="dash-head text-center">List of Business Profiles</h4>
            </div>

            <div class="flex-end">
              <button
                type="button"
                className="btn btn-add"
                onClick={() => navigate("/addbusinessprofile")}
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <section className="add-category">
          <div className="card dash_table p-3">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" className="text-left">
                    #
                  </th>
                  <th scope="col">Name</th>
                  <th scope="col">Category</th>
                  <th scope="col">description</th>
                  <th scope="col" className="text-center">
                    Image
                  </th>
                  <th scope="col" className="text-center">
                    Actions
                  </th>
                  <th scope="col" className="text-center">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems != null &&
                  currentItems.map((profile, index) => {
                    return (
                      <tr>
                        <th key={index}>{index + 1}</th>
                        <td>{profile?.businessName ?? "N/A"}</td>
                        <td>
                          {profile?.businessCategory?.businessCategoryName ??
                            "N/A"}
                        </td>
                        <td className="profile_description">
                          <p>
                            {profile?.description != null ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: profile?.description,
                                }}
                              />
                            ) : (
                              "N/A"
                            )}
                          </p>
                        </td>
                        <td className="">
                          {profile?.profilePic ? (
                            <div className="profile_img mx-auto">
                              <img
                                src={
                                  profile.profilePic != null
                                    ? process.env.REACT_APP_AWS_IMAGE_URL +
                                      "businessprofilepics/" +
                                      profile.profilePic
                                    : "Image not available"
                                }
                              />
                            </div>
                          ) : (
                            <div className="profile_img mx-auto">
                              <img src={placeholder} />
                            </div>
                          )}
                        </td>
                        <td className="action_">
                          <button
                            className="action_btn"
                            onClick={() =>
                              navigate(`/editbusinessprofile/${profile._id}`)
                            }
                          >
                            <i>
                              <Ci.CiEdit />
                            </i>
                          </button>
                        </td>
                        <td className="text-center">
                          <button
                            className="action_btn text-center"
                            onClick={() => {
                              setSelectedId(profile._id);
                              setAcknowledge(true);
                            }}
                          >
                            <i>
                              <Bs.BsTrash />
                            </i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"..."}
              onPageChange={handlePageChange}
              pageCount={Math.ceil(profileList.length / itemsPerPage)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              containerClassName={"pagination"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              disabledClassName={"disabled"}
              activeClassName={"paging__link--active"}
            />
          </div>
        </section>
      </div>
    </div>
  );
}

export default BusinessProfile;
